import { REHYDRATE } from "redux-persist";
import ContractActionTypes from "./types";
import AuthenticationUtils from "services/authentication/utils";

const initialState = {
  contracts: [],
  contract: undefined,
};

const ContractReducer = (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      if (
        action.payload &&
        AuthenticationUtils.shouldPersistSession(action.payload.Authentication)
      ) {
        return state;
      }
      return initialState;
    case ContractActionTypes.SET_CONTRACT:
    case ContractActionTypes.SWITCH_CONTRACT:
      return {
        ...state,
        contract: action.contract,
      };
    case ContractActionTypes.SET_CONTRACTS:
      return {
        ...state,
        contracts: action.contracts,
      };
    default:
      return state;
  }
};

export default ContractReducer;
